import {
    Button,
    Card,
    CardMedia,
    Divider,
    Grid,
    makeStyles,
    Typography,
  } from "@material-ui/core";
  import "./HeroCard.css";
  import React, { Component } from "react";
  import adyaBannerlogo from "../../../../images/indian-bank/Group 14894 (1).svg";
  
  // const useStyles = makeStyles({
  //   root: {
  //     maxWidth: 345,
  //   },
  //   media: {
  //     height: 140,
  //   },
  // });
  
  export default class AgrLinkData extends Component {
    constructor(props) {
      super(props);
    }
  
    render() {
      // const { classes } = this.props;
      console.log("Link Card============================");
      return (
        // <Grid container alignItems="center">
        <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70">
          <Grid item xs>
            <Typography
              variant="button"
              display="block"
              align="center"
              gutterBottom
            >
              {/* {this.props.herocardData.title} */}
              <h5 className="hero_card_title">{this.props.herocardData.title}</h5>
            </Typography>
            <Grid item xs>
              <Card>
                <CardMedia component="img" image={adyaBannerlogo} alt="ib" />
              </Card>
            </Grid>
          </Grid>
          <Divider variant="middle" />
          <div className="herocard_div">
            <Grid item>
              <Typography
                variant="caption"
                display="block"
                align="center"
                gutterBottom
              >
                {/* {this.props.herocardData.subtitle} */}
                <h6 className="hero_card_subtitle">
                </h6>
              </Typography>
            </Grid>
            <Typography
              variant="caption"
              display="block"
              gutterBottom
              className="typography_link_center"
            >
              <Button
                variant="outlined"
                size="small"
                href={this.props.herocardData.data.MESSAGE.RESULT[0].BODY.message}
                target="_blank"
              >
                Click here for furthur details
              </Button>
            </Typography>
          </div>
        </div>
        // </Grid>
      );
    }
  }
  